module.exports = __webpack_public_path__ + "img/approvals.67ebc92c.svg";